import { AccountAttributesEnum } from '../../shared/enums';

export interface User {
    account_attributes: AccountAttributesEnum[];
    account_creation_date: string;
    account_dy_domain: string;
    account_id: number;
    account_name: string;
    account_sf_domain: string;
    account_type: number;
    admin?: boolean;
    ads_intel_enabled?: boolean;
    allow_early_access: boolean;
    billing_period_end: string;
    billing_period_start: string;
    creation_date: string;
    creditLimit?: any;
    creditUsed?: number;
    email: string;
    enabled?: boolean;
    external_id: string;
    first_name: string;
    hasError?: boolean;
    has_licence_credits: boolean;
    hasLimitError?: boolean;
    hasOverallLimitError?: boolean;
    hasRoDError?: boolean;
    hasRoDLimitError?: boolean;
    hasRoDOverallLimitError?: boolean;
    id: number;
    is_active_email: boolean;
    is_admin: boolean;
    is_ads_intel_user?: boolean;
    is_autorenew: boolean;
    is_chrome_only: boolean;
    is_linked: boolean;
    is_deleted?: boolean;
    is_ops_admin?: boolean;
    ai_content_access?: boolean;
    is_prospect_connect_user?: boolean;
    job_change_enabled: boolean;
    job_change_limit: number;
    job_change_freemium: boolean;
    last_name: string;
    length?: number;
    lengthUnits?: string;
    prospect_connect_enabled?: boolean;
    referred_by: string;
    rev_driver_version?: string;
    rod_daily_digest_email: boolean;
    rodCreditLimit?: number;
    rodLengthUnits?: string;
    rodCreditUsed?: number;
    rodLength?: number;
    roles: string[];
    selected?: boolean;
    service_credits: ServiceCreditItem[];
    sso_enabled: boolean;
    user_limit: number;
    user_meta: any;
    user_roles: any;
    uuid: string;
}

export interface UserResponse {
    users: Array<User>;
}

export interface ServiceCreditItem {
    account_credits_remaining: number;
    accounts_credit_limit_id: number;
    ad_hoc_credits: number;
    billing_period_start: string;
    credit_limit: number;
    credit_type: ServiceCreditTypesEnum;
    credit_type_id: number;
    credits_remaining: number;
    credits_used: number;
    is_deprecated: boolean;
    label: string;
    license_credit_limit: number;
    license_credits_used: number;
    proxy_service_name: string;
    total_account_credit_limit: number;
    total_credit_limit: number;
}

export enum ServiceCreditTypesEnum {
    CC_SF_ENRICHMENT = 'CC-SF-Enrichment',
    COMBINED = 'Combined',
    COMPANY = 'Company',
    COMPANY_SEARCH = 'Company-Search',
    CONTACT = 'Contact',
    BOUNCEINTEL = 'BounceIntel',
    ENRICHMENT = 'Enrichment',
    MARKETO_ENRICHMENT = 'Marketo-Enrichment',
    SEARCH = 'Search',
    SIGNATURE = 'Signature',
    REVEAL = 'Reveal',
    RESEARCH = 'Research',
    ROD = 'RoD',
}

export interface UserMetaData {
    allowExportOfPendingVerificationContacts?: string;
    bypassCSVName?: string;
    contactJoyRide?: string;
    csvExportEmployeeCount?: string;
    csvExportRevenue?: string;
    csvExportStateAsAbbreviation?: string;
    csvExportCountryAsAbbreviation?: string;
    csvLargeExportAllowed?: string;
    dyDisplayName?: string;
    dyEmail?: string;
    dyInstanceUrl?: string;
    filtersHsDisplayName?: string;
    filtersHsEmail?: string;
    hsCreateNewAccounts?: string;
    hsCrmStatus?: string;
    hsDisplayName?: string;
    hsDuplicateResolution?: string;
    hsEmail?: string;
    hsExportType?: string;
    hsOrphanRecords?: string;
    hsPromptForLeadOwners?: string;
    hsPromptForWorkflow?: string;
    listJoyRid?: string;
    orDefaultOwnerIsConnectedUser?: string;
    orDisplayName?: string;
    orEmail?: string;
    orPromptForLeadOwners?: string;
    orPromptForSequence?: string;
    orPromptForTags?: string;
    rodExpressIntentSplash?: string;
    sfAccountMapping?: string;
    sfAllowExportAsContact?: string;
    sfAllowExportAsLead?: string;
    sfCreateNewAccounts?: string;
    sfDefaultOwnerIsConnectedUser?: string;
    sfDisplayName?: string;
    sfDuplicateResolution?: string;
    sfEmail?: string;
    sfExportCountryAsAbbreviation?: string;
    sfExportEmployeeCount?: string;
    sfExportFax?: string;
    sfExportHQPhone?: string;
    sfExportRevenue?: string;
    sfExportStateAsAbbreviation?: string;
    sfExportTracking?: string;
    sfOrphanRecords?: string;
    sfPromptForCampaigns?: string;
    sfPromptForLeadOwners?: string;
    slDisplayName?: string;
    slEmail?: string;
    slPromptForCadences?: string;
    slPromptForTags?: string;
    zhAllowExportAsContact?: string;
    zhAllowExportAsLead?: string;
    zhApiUrl?: string;
    zhCreateNewAccounts?: string;
    zhDefaultOwnerIsConnectedUser?: string;
    zhDisplayName?: string;
    zhDuplicateResolution?: string;
    zhEmail?: string;
    zhOrphanRecords?: string;
    zhPromptForCampaigns?: string;
    zhPromptForLeadOwners?: string;
    zhRefreshToken?: string | null;

    // fields to check for existance

    allowedTiers?: string;
    allowIntentExport?: string;
    bypassClearSelectionAfterCsv?: string;
    bypassClearSelectionAfterExport?: string;
    mktUser?: string;
    salesforceSandbox?: string;
}
